import {
    faCheckDouble,
    faMoneyBillWave,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavLink } from "react-router-dom";
import { useUserInfor } from "../../../../../Context/User";
import { ACESSOS } from "../../../../../Routes/Acessos";
import { mostrarNavDeTela } from "../../../../../Validations/UsuarioTela";

export function SubNavMenuFinanceiroCobranca() {
    const { UserInfor } = useUserInfor();

    return (
        <>
            {mostrarNavDeTela(
                ACESSOS.COBRANCA.TELAS.SERASA.ID_TELA,
                UserInfor.TELAS
            ) && (
                <li className="menu-item">
                    <NavLink
                        to={ACESSOS.COBRANCA.TELAS.SERASA.DS_PATH}
                        exact
                        activeClassName="active"
                        className="menu-link"
                    >
                        {" "}
                        <span className="svg-icon menu-icon">
                            <FontAwesomeIcon icon={faMoneyBillWave} />
                        </span>
                        <span className="menu-text">Serasa</span>
                    </NavLink>
                </li>
            )}

            {mostrarNavDeTela(
                ACESSOS.COBRANCA.TELAS.APROVACAO_RENEGOCIACOES.ID_TELA,
                UserInfor.TELAS
            ) && (
                <li className="menu-item">
                    <NavLink
                        to={
                            ACESSOS.COBRANCA.TELAS.APROVACAO_RENEGOCIACOES
                                .DS_PATH
                        }
                        exact
                        activeClassName="active"
                        className="menu-link"
                    >
                        <span className="svg-icon menu-icon">
                            <FontAwesomeIcon icon={faCheckDouble} />
                        </span>
                        <span className="menu-text">
                            Aprovação de Renegociações
                        </span>
                    </NavLink>
                </li>
            )}
        </>
    );
}
